const MONTHS_SHORT = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export function dayOrdinal(day: number): string {
  if (day >= 11 && day <= 13) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

/** Platform timestamp: `14:12 on 15th Oct` (local time). */
export function formatTimestamp(timestamp: string): string {
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return timestamp;
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const day = d.getDate();
  const month = MONTHS_SHORT[d.getMonth()];
  return `${hours}:${minutes} on ${dayOrdinal(day)} ${month}`;
}

/** Calendar-day buckets (`YYYY-MM-DD`) — shown as noon on that calendar day. */
export function formatTimestampFromDateIso(dateIso: string): string {
  const trimmed = dateIso.trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (m) {
    const day = Number(m[3]);
    const monthIndex = Number(m[2]) - 1;
    const month = MONTHS_SHORT[monthIndex] ?? m[2];
    return `12:00 on ${dayOrdinal(day)} ${month}`;
  }
  return formatTimestamp(trimmed);
}
